import { TableColumn } from "./dataInterface";

export const tossUpAnalysysTableColumn: TableColumn = {
  title: "エントリー分析",
  detail: false,
  detailTitle: "",
  detailColumn: "",
  detailKey: [""],
  addTitle: "",
  editAuth: [],
  tableFunction: [],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "analysys_year_month",
      name: "表示範囲",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "analysys_year_month",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "analysys_granularity",
      name: "粒度",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "list",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_aggregation_item",
      name: "集計項目",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "list",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_analysys_sub_count",
      name: "サブカラム",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "list",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_analysys_division_admin",
      name: "表示区分",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "list",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_analysys_division_partner",
      name: "表示区分",
      tableDetailAuth: ["パートナー", "営業アカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "list",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_analysys_count_type",
      name: "計上タイプ",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: false,
      serchType: "list",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_analysys_status",
      name: "ステータス",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "list",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "category_name_list",
      name: "カテゴリー",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "category",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_company_name",
      name: "トスアップパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_company_group_name",
      name: "トスアップグループ",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "group",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_account_name",
      name: "トスアップアカウント",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "sale_account",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "closer_company_name",
      name: "クロージングパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "closer_company_group_name",
      name: "クロージンググループ",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "group",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "closer_account_name",
      name: "クロージングアカウント",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "sale_account",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "closer_product_name",
      name: "クロージング商材",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "product",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  subTable: [],
};
